<template>
  <div id="center-img">
    <img src="../../assets/images/hand.png" alt="">
  </div>
</template>

<script>
export default {
  name: "CenterImage",
  components: {}
};
</script>

<style lang="scss" scoped>
#center-img {
  width: 100%;
  margin-top: 50px;
  margin-bottom: 30px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
